import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form, Modal, Container, Row, Col } from "react-bootstrap";

import './VariationsHoursModal.scss';

import messages from "../../assets/i18n";
import ButtonStandard from "../ButtonStandard/ButtonStandard";
import CustomHour from "../CustomHour/CustomHour";
import Switch from "../Switch/Switch";
import txWeekDays from '../../helpers/txWeekDays';
import { convertHourToDate } from '../../helpers/convertHour'
import { ToastMessage } from "../../components";

function VariationsHoursModal(props) {

    const lang = useSelector(state => state.language.name);

    const hours = useSelector(state => state.gateVariations.gateVariationHours.horarios)
    const { initialDate, finalDate, motivo, gateSelect, idGate, idVariation, lastDate } = useSelector(state => state.gateVariations)
    const user = useSelector(state => state.authorization.chapa)
    const [toastMessage, setToastMessage] = useState('');
    const [toastClass, setToastClass] = useState('toast-error');
    const [show, setShow] = useState(false);

    const dispatch = useDispatch();

    const [dynamicCapacityEnable, setDynamicCapacityEnable] = useState(props.value);

    const minimalDate = new Date()

    while (minimalDate.getUTCDay() !== 0) {
        minimalDate.setDate(minimalDate.getDate() + 1)
    }

    const errorHour = hours => (
        hours.reduce((prev, current) => (convertHourToDate(current.hrFim) >= convertHourToDate(current.hrInicial) ? prev : [...prev, current]), [])
    )

    const dispatchGateVariation = (action) => {
        const errors = errorHour(hours)
        if (errors.length > 0) {
            const txError = messages[lang].ErrorSalveCdHors;
            let msg = errors.reduce((prev, current) => (prev + ' ' + messages[lang][txWeekDays(current.idDiaSemana)] + ','), txError);
            setShow(true);
            setToastMessage(msg.substr(0, msg.length - 1));
            setToastClass('toast-error');
        }
        else {
            if (action === 'create') {
                dispatch({
                    type: "SAVE_GATE_VARIATION",
                    data: {
                        idPortao: idGate,
                        motivo: motivo,
                        dataInicial: initialDate,
                        dataFinal: finalDate,
                        novosHorarios: hours,
                        usuario: user
                        //Mock para ambiente local
                        //usuario: 'chapa'
                    }
                });
            } else {
                dispatch({
                    type: "UPDATE_GATE_VARIATION",
                    data: {
                        idPortao: idGate,
                        motivo: motivo,
                        novosHorarios: hours,
                        usuario: user,
                        //Mock para ambiente local
                        //usuario: 'chapa'
                        id: idVariation
                    },
                });
            }
            dispatch({
                type: "SET_VARIATION_HOURS_MODAL_CLEAN"
            });

            props.onHide(false);
        }
    }


    const handleInitialDate = (e) => {
        e.preventDefault()
        const initialDate = e.target.value

        const initialDateObj = new Date(Date.parse(initialDate))
        if (initialDateObj.getUTCDay() !== 0) {
            alert(messages[lang].messagesCode.variation004)
            return
        }

        dispatch({
            type: "SET_INITIAL_DATE",
            payload: {
                initialDate: initialDate
            }
        });

        const finalDate = new Date(Date.parse(initialDate))

        finalDate.setDate(finalDate.getDate() + 6)

        const finalDateString = finalDate.toISOString().substring(0, 10)

        dispatch({
            type: "SET_FINAL_DATE",
            payload: {
                finalDate: finalDateString
            }
        });
    }

    const handleMotivo = (motivo) => {
        dispatch({
            type: "SET_MOTIVO_VARIATION",
            payload: {
                motivo: motivo
            }
        });
    }

    const handleDynamicCapacity = (capacidadeDinamica) => {
        setDynamicCapacityEnable(capacidadeDinamica);
    }

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            className="variation-hours-modal"
            centered
        >
            <ToastMessage show={show} setShow={setShow} message={toastMessage} toastClass={toastClass} ></ToastMessage>
            <Modal.Body>
                <Container className="px-0 mb-5 pb-5">
                    <Row>
                        <Col xs={2}>
                            <Switch
                                name={messages[lang].dynamicCapacity}
                                checked={dynamicCapacityEnable}
                                onChange={e => handleDynamicCapacity(e.target.checked)}
                            />
                        </Col>
                        <Col xs={5}>
                            <Form.Group bsPrefix={"form-group-custom"} >
                                <Form.Label>{messages[lang].reason}:</Form.Label>
                                <Form.Control
                                    type="text"
                                    maxLength={250}
                                    placeholder={messages[lang].textEnterReasonGateVariation}
                                    value={motivo}
                                    required={true}
                                    onChange={e => handleMotivo(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col xs={2}>
                            <Form.Group bsPrefix={"form-group-custom"} >
                                <Form.Label>{messages[lang].initialDate}:</Form.Label>
                                <Form.Control
                                    id="initialDate"
                                    type="date"
                                    isValid={false}
                                    value={initialDate}
                                    required={true}
                                    step={7}
                                    min={minimalDate.toISOString().split("T")[0]}
                                    max={lastDate}
                                    disabled={props.action === 'edit' ? true : false}
                                    onChange={handleInitialDate}
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={2}>
                            <Form.Group bsPrefix={"form-group-custom"} >
                                <Form.Label>{messages[lang].finalDate}:</Form.Label>
                                <Form.Control
                                    id="finalDate"
                                    type="date"
                                    value={finalDate}
                                    required={true}
                                    disabled />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <Form.Group bsPrefix={"form-group-custom"} >
                                <Form.Label>{messages[lang].gate}:</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={gateSelect}
                                    maxLength={50}
                                    disabled />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="cd-hours">
                                <Container className="pb-4">
                                    <Row className="cd-hours-body">
                                        {hours.map((hour, i) => {
                                            return (
                                                <CustomHour action={props.action} type={"gate"} capacidade={hour.capacidade} intervalo={hour.intervalo} key={i} hours={hours} hour={hour} indice={i} dynamicCapacity={dynamicCapacityEnable} />
                                            )
                                        })}
                                    </Row>
                                </Container>
                            </div>

                        </Col>
                    </Row>

                </Container>

            </Modal.Body>
            <Modal.Footer>
                <ButtonStandard
                    id="load_modal_add_order_button"
                    text={messages[lang].save}
                    textClass="text-3"
                    disabled={motivo.trim().length <= 0 || initialDate.trim().length <= 0}
                    className="btn btn-primary btn-standard px-4 py-1"
                    onClick={() => dispatchGateVariation(props.action, hours)}
                />
            </Modal.Footer>
        </Modal>
    )
}

export default VariationsHoursModal;